import validator from 'validator';

// eslint-disable-next-line import/prefer-default-export
export const validate = (name: string, value: string) => {
  switch (name) {
    case 'email': {
      const emails = value.split(',');

      if (emails.length <= 5) {
        if (!emails.every((email) => validator.isEmail(email.trim()))) {
          return 'Enter a valid email address';
        }
      } else {
        return 'Maximum of 5 emails are allowed';
      }

      break;
    }
    default:
      break;
  }
  return '';
};
